import React, { useEffect, useState } from 'react';
import { getTravelRoute } from '@services/travelRoute';
import decodePolyline from '@utils/decodePolyline';
import { Polyline, useMap } from 'react-leaflet';
import { validLocation } from './MonitoringMapContants';

export async function fetchRoute(journeyId: string) {
  try {
    const data = await getTravelRoute(journeyId);
    const route = decodePolyline(data.geometry);
    return route.map(([longitude, latitude]) => [longitude, latitude]);
  } catch (error) {
    console.error(`Failed to fetch travel route.`);
    return [];
  }
}

export function Routing({
  origin,
  destination,
  journeyId,
}: {
  origin: { lat: number; lon: number };
  destination: { lat: number; lon: number };
  journeyId: string;
}) {
  const map = useMap();
  const [route, setRoute] = useState<any[]>([]);

  useEffect(() => {
    if (validLocation(origin) && validLocation(destination)) {
      fetchRoute(journeyId).then((routePoints) => {
        setRoute(routePoints);
        if (route.length > 0) map.fitBounds(routePoints);
      });
    }
  }, [origin, destination, map]);

  return route.length > 0 ? (
    <Polyline positions={route} color="#000" weight={1} />
  ) : null;
}
